import gql from "graphql-tag";

export const END_DEAL = gql`
  mutation end_deal($id: uuid!) {
    update_deals_by_pk(
      pk_columns: { id: $id }
      _set: { manually_end_at: "now()" }
    ) {
      id
    }
  }
`;
